'use client'

import Benefits from './Benefits'

export default Benefits
